<template>
  <!-- 34페이지 참고 -->
  <aside
    class="aside collapsed"
    v-show="!isShowAside"
    @mouseover="handleMouseOver"
  ></aside>
  <aside
    :class="{ aside: true, active: openAsideKey === 1 }"
    v-show="isShowAside"
    id="asideView"
  >
    <div class="aside-inner">
      <ul class="aside-nav-group">
        <!-- 즐겨찾기 -->
        <li>
          <button
            :class="{ active: openAsideKey === 1 }"
            @click="onChangeAside(1)"
          >
            <icon-favorites />
            <span class="aside-nav-text">{{ $t("button.favorite") }}</span>
          </button>
          <div class="aside-collapsed favorites-box" v-if="openAsideKey === 1">
            <Bookmark @close="close" @updateModified="updateModified" />
          </div>
        </li>
        <!-- 약품 -->
        <li v-if="isDrugInfoVisible">
          <button
            :class="{
              active: openAsideKey === 2,
            }"
            @click="onChangeAside(2)"
          >
            <icon-drug />
            <span class="aside-nav-text">{{ $t("title.drug_info") }}</span>
          </button>
          <div class="aside-collapsed medicine-box" v-if="openAsideKey === 2">
            <DrugInfo @close="close" />
          </div>
        </li>
      </ul>
      <ul class="aside-nav-group">
        <!-- 메일 -->
        <li>
          <button
            :class="{
              active: openAsideKey === 4 && !customer.impossibleExcel,
            }"
            @click="onChangeAside(4)"
            :disabled="
              (!exportUrl && !patternExportData) || customer.impossibleExcel
            "
          >
            <icon-mail />
            <span class="aside-nav-text">{{ $t("button.email_export") }}</span>
          </button>
          <div
            class="aside-collapsed"
            v-if="openAsideKey === 4 && !customer.impossibleExcel"
          >
            <button class="txt-btn" @click="exportEmail">
              {{ $t("button.email_export") }}
            </button>
          </div>
        </li>
        <!-- 엑셀 -->
        <li>
          <button
            :class="{
              active: openAsideKey === 3 && !customer.impossibleExcel,
            }"
            @click="onChangeAside(3)"
            :disabled="
              (!exportUrl && !patternExportData) || customer.impossibleExcel
            "
          >
            <icon-excel />
            <span class="aside-nav-text">{{ $t("button.excel_export") }}</span>
          </button>
          <div
            class="aside-collapsed"
            v-if="openAsideKey === 3 && !customer.impossibleExcel"
          >
            <button class="txt-btn" @click="exportExcel">
              {{ $t("button.excel_export") }}
            </button>
          </div>
        </li>
        <!-- 메뉴얼 -->
        <li>
          <button
            :class="{
              active: openAsideKey === 7,
            }"
            @click="onChangeAside(7)"
          >
            <icon-manual />
            <span class="aside-nav-text">{{
              $t("button.manual_download")
            }}</span>
          </button>
          <div class="aside-collapsed" v-if="openAsideKey === 7">
            <button class="txt-btn" @click="downLoadManual()">
              {{ $t("button.manual_download") }}
            </button>
          </div>
        </li>
        <!-- } 20230704 메뉴얼 버튼 추가 -->
      </ul>
      <ul class="aside-nav-group" style="margin-top: auto; border-top: none">
        <li>
          <button
            :class="{
              active: openAsideKey === 6,
            }"
            @click="onChangeAside(6)"
          >
            <span
              class="material-symbols-outlined"
              style="font-variation-settings: 'wght' 400; color: #bbb"
              :title="$t('button.aside_hidden')"
            >
              more_horiz
            </span>
          </button>
          <div class="aside-collapsed" v-if="openAsideKey === 6">
            <button class="txt-btn" @:click="showAside">
              {{ $t("button.aside_hidden") }}
            </button>
          </div>
        </li>
      </ul>
    </div>
    <div
      class="alert-dialog-overlay"
      :style="{
        backgroundColor:
          openAsideKey === 10 ? 'rgba(0, 0, 0, 0.5)' : 'transparent',
      }"
      v-if="openAsideKey > -1"
      @click="openAsideKey = -1"
    ></div>

    <!-- 확인 다이얼로그 -->
    <ConfirmDialog
      v-if="isConfirmDialogOpen"
      title="변경 사항이 저장되지 않았습니다."
      message="현재 창을 닫으면 변경 사항이 저장되지 않습니다. 계속하시겠습니까?"
      @confirmed="confirmMenuChange"
    />
  </aside>

  <!-- <FavoriteSettingModal v-if="isFavoriteSettingModalOpen" />
  <FavoriteModifyModal v-if="isFavoriteModifyModalOpen" />
  <AlertDialog
    v-if="isAlertDialogOpen"
    :maxWidthOption="alertDialog.maxWidthOption"
    :title="alertDialog.title"
    :message="alertDialog.message"
    :afterEvent="alertDialog.afterEvent"
    @confirm="closeAlertDialog"
  />
  <ConfirmDialog
    v-if="isConfirmDialogOpen"
    :maxWidthOption="alertDialog.maxWidthOption"
    :title="confirmDialog.title"
    :message="confirmDialog.message"
    :data1="confirmDialog.data1"
    :data2="confirmDialog.data2"
    @confirmed="handleConfirmDialog"
  /> -->
</template>

<script>
import constants from "@/data/constants.js";
import {
  ref,
  defineComponent,
  onMounted,
  computed,
  reactive,
  watchEffect,
} from "vue";
import { useI18n } from "vue-i18n";
import AsideFavorite from "./favorite/AsideFavorite.vue";
import FavoriteSettingModal from "./favorite/FavoriteSettingModal.vue";
import FavoriteModifyModal from "./favorite/FavoriteModifyModal.vue";
import DrugInfo from "@/views/pharmarcy/DrugInfo.vue";
import Bookmark from "@/views/pharmarcy/Bookmark.vue";
//지연호출
// import { defineAsyncComponent } from "vue";
// const DrugInfo = defineAsyncComponent(() => import("@/views/pharmarcy/DrugInfo.vue"));
// const Bookmark = defineAsyncComponent(() => import("@/views/pharmarcy/Bookmark.vue"));
import AlertDialog from "@/components/AlertDialog.vue";
import ConfirmDialog from "@/components/ConfirmDialog.vue";
import { useCommonStore } from "@/store/common";
import { useFavoritesStore } from "@/store/favorites";
import { useContentsStore } from "@/store/contents.js";
import { storeToRefs } from "pinia";
import useManualDownLoad from "@/lib/useManualDownLoad.js";
import menuData from "@/data/menuData.js";

import IconFavorites from "@/components/icon/IconFavorites.vue";
import IconExtract from "@/components/icon/IconExtract.vue";
import IconDrug from "@/components/icon/IconDrug.vue";
import IconMail from "@/components/icon/IconMail.vue";
import IconExcel from "@/components/icon/IconExcel.vue";
import IconManual from "@/components/icon/IconManual.vue";
// import IconAnalysisRecords from "@/components/icon/IconAnalysisRecords.vue";
// import Extraction from "@/views/pharmarcy/Extraction.vue";
// import AnalysisRecord from "@/views/pharmarcy/AnalysisRecord.vue";
// import TreeDraggable from "@/views/pharmarcy/TreeDraggable.vue";

export default defineComponent({
  name: "Aside",
  components: {
    // TreeDraggable,
    // AnalysisRecord,
    // Extraction,
    // IconAnalysisRecords,
    Bookmark,
    IconManual,
    IconExcel,
    IconMail,
    IconDrug,
    IconExtract,
    IconFavorites,
    DrugInfo,
    AsideFavorite,
    FavoriteSettingModal,
    FavoriteModifyModal,
    AlertDialog,
    ConfirmDialog,
  },
  setup() {
    const isShowAside = ref(true);
    const asideData = ref([
      {
        key: 1,
        name: "",
        isCollapsed: false,
      },
      {
        key: 2,
        name: "",
        isCollapsed: false,
      },
      {
        key: 3,
        name: "",
        isCollapsed: false,
      },
      {
        key: 4,
        name: "",
        isCollapsed: false,
      },
      {
        key: 5,
        name: "",
        isCollapsed: false,
      },
      {
        key: 6,
        name: "",
        isCollapsed: false,
      },
      {
        key: 7,
        name: "",
        isCollapsed: false,
      },
      {
        key: 8,
        name: "",
        isCollapsed: false,
      },
    ]);

    const { t } = useI18n();
    const contentsStore = useContentsStore();
    const { exportUrl, printPdfUrl, patternExportData, lastLang } =
      storeToRefs(contentsStore);

    const showAside = () => {
      const body = document.querySelector("body");
      const header = document.querySelector(".header");

      body.classList.toggle("is-expansion");
      header.classList.toggle("is-expansion");

      isShowAside.value = !isShowAside.value;
    };

    const commonStore = useCommonStore();
    const favoritesStore = useFavoritesStore();
    const { openAsideKey, serviceList, customer } = storeToRefs(commonStore);
    const { productType } = storeToRefs(commonStore);

    const {
      loading,
      isFavoriteModifyModalOpen,
      isFavoriteSettingModalOpen,
      isAlertDialogOpen,
      alertDialog,
      isConfirmDialogOpen,
      confirmDialog,
    } = storeToRefs(favoritesStore);
    const confirmed = ref(null);
    const menuCode = ref("");

    const isDrugInfoVisible = computed(() => {
      return `${productType.value}` !== '6';
    });

    const closeAlertDialog = () => {
      isAlertDialogOpen.value = false;
    };

    const isModified = ref(false); // 수정 여부 상태
    const onChangeAside = (key) => {
      // 현재 URL에서 마지막 경로를 가져와 메뉴 코드 설정
      const url = window.location.href;
      const lastUrl = url.split("/").findLast(() => true);
      let menu = menuData.find((menu) => menu.path === "/" + lastUrl);
      if (!menu) {
        // 지정되지 않은 메뉴로 이동 시 메인 메뉴로 설정
        menu = menuData.find((menu) => menu.path === "/");
      }
      menuCode.value = menu.code;

      // 현재 열려 있는 메뉴를 다시 클릭한 경우 아무 동작하지 않음
      if (openAsideKey.value === key) {
        return;
      }

      // 수정 상태인 경우 확인 다이얼로그 표시
      if (isModified.value) {
        commonStore.openAlertDialog({
          message: t("message.modify_favorite_cancel"), // "변경 사항이 저장되지 않았습니다. 계속하시겠습니까?"
          afterEvent: () => {
            // 확인 버튼을 클릭한 경우
            isModified.value = false; // 수정 상태 초기화
            openAsideKey.value = key; // 메뉴 변경
          },
          afterCancel: () => {},
        });
        return;
      }

      // 수정 상태가 아닌 경우 메뉴 변경
      openAsideKey.value = openAsideKey.value === key ? null : key;
    };

    const close = () => {
      openAsideKey.value = null; // 창 닫기 처리
      isModified.value = false;
    };

    const handleConfirmDialog = (event, code, value) => {
      if (value) {
        // console.log(value);
        if (value) {
          favoritesStore.handleOverWriteFavoriteDialog();
        }
      }
      confirmed.value = value;
      isConfirmDialogOpen.value = false;
    };

    const menuType = computed(() => {
      return _.find(serviceList.value, { code: menuCode.value })?.type ?? 1;
    });

    const exportExcel = async () => {
      if (menuType.value === 1) {
        await contentsStore.onReportExcel(
          menuCode.value,
          lastLang.value,
          commonStore.openAlertDialog
        );
      } else {
        await contentsStore.onPatternExcel(
          menuCode.value,
          "report_excel",
          commonStore.openAlertDialog,
          null,
          lastLang.value
        );
      }
    };
    const exportEmail = async () => {
      if (menuType.value === 1) {
        await contentsStore.onReportEmail(
          menuCode.value,
          lastLang.value,
          commonStore.openAlertDialog
        );
      } else {
        await contentsStore.onPatternEmail(
          menuCode.value,
          "report_excel",
          commonStore.openAlertDialog,
          lastLang.value
        );
      }
    };

    const printPdf = () => {
      window.open(printPdfUrl.value);
    };

    const isClickedOutside = ref(false);

    onMounted(() => {
      exportUrl.value = "";
      printPdfUrl.value = "";
    });

    //매뉴얼다운로드
    const { manualDownLoad } = useManualDownLoad();
    const downLoadManual = async () => {
      manualDownLoad(menuCode.value);
    };

    const handleMouseOver = () => {
      showAside();
      isShowAside.value = true;
      asideData.value[5].isCollapsed = true; //사이드바자동숨기기버튼
      const asideView = document.querySelector("#asideView");
      asideView.style.display = "flex"; // 배경색 변경
    };

    // Bookmark에서 수정 여부 업데이트
    const updateModified = (modified) => {
      isModified.value = modified;
    };

    return {
      constants,

      isShowAside,
      showAside,
      asideData,
      openAsideKey,
      onChangeAside,
      customer,

      isFavoriteModifyModalOpen,
      isFavoriteSettingModalOpen,

      isAlertDialogOpen,
      alertDialog,
      closeAlertDialog,

      isConfirmDialogOpen,
      confirmed,
      confirmDialog,
      handleConfirmDialog,

      FavoriteSettingModal,
      FavoriteModifyModal,

      menuType,

      exportUrl,
      printPdfUrl,
      patternExportData,
      exportExcel,
      exportEmail,
      printPdf,
      isClickedOutside,

      downLoadManual,
      menuCode,
      handleMouseOver,
      productType,

      updateModified,
      isModified,
      close,

      isDrugInfoVisible,
    };
  },
});
</script>

<style scoped>
.aside {
  display: flex;
  position: fixed;
  top: 0;
  right: 0;
  width: 60px;
  height: 100%;
  background-color: #fff;
  z-index: 200;
}

.aside::before {
  position: absolute;
  left: 0;
  top: 0;
  content: "";
  width: 1px;
  height: 100%;
  background-color: #ddd;
}

.collapsed {
  width: 15px;
}

.aside-inner {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 63px 0;
}

.aside-nav-group {
  position: relative;
  margin-bottom: 28px;
}

.aside-nav-group:nth-of-type(1):after {
  content: "";
  height: 3px;
  position: absolute;
  bottom: 0;
  left: 16px;
  width: 28px;
  border-radius: 3px;
  background-color: #ebebeb;
}

.aside-nav-group > li {
  position: relative;
  margin: 0 4px 28px;
}

.aside-nav-group > li > button {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 52px;
  min-height: 40px;
  position: relative;
  padding: 0 4px;
}

.aside-nav-group > li > button:hover,
.aside-nav-group > li > button.active {
  border-radius: 4px;
  background: #f9fafb;
}

.aside-nav-group > li > button.active:before {
  content: "";
  position: absolute;
  left: -4px;
  top: 0;
  bottom: 0;
  width: 2px;
  background: #174fdc;
}

.aside-nav-group > li > button:disabled {
  opacity: 0.4;
  cursor: not-allowed;
  pointer-events: none;
}

.aside-nav-group > li > button .material-symbols-outlined {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  color: #595959;
  background-color: #fff;
  border-radius: 50%;
  transition: all 0.3s;
  font-variation-settings: "wght" 200;
}

.aside-nav-group > li > button:hover .material-symbols-outlined {
  background-color: #ebebeb;
}

.aside-nav-group > li > button.active .material-symbols-outlined {
  color: #fff !important;
  background-color: var(--primary-color);
}

.aside-nav-group > li > button .aside-nav-text {
  display: block;
  color: #9a9a9a;
  text-align: center;
  font-size: 12px;
  font-weight: 400;
  line-height: normal;
  letter-spacing: -0.36px;
  margin-top: 6px;
}

.aside-collapsed {
  position: absolute;
  right: 47px;
  top: 50%;
  width: fit-content;
  padding: 10px 0;
  font-size: 13px;
  white-space: nowrap;
  border: var(--border-line);
  background-color: #fff;
  box-shadow: -4px 6px 12px rgba(6, 10, 19, 0.2);
  transform: translateY(-50%);
  z-index: 3;
}

.aside.active::after {
  position: fixed;
  left: 0;
  right: 60px;
  top: 0;
  content: "";
  height: 100%;
  z-index: 1;
  background-color: rgba(0, 0, 0, 0.47);
}

.aside-collapsed .txt-btn {
  display: block;
  width: 100%;
  height: 30px;
  padding: 0 20px;
  font-size: inherit;
  text-align: left;
  border-radius: 0;
  transition: all 0.3s;
}

.aside-collapsed .txt-btn:hover {
  background-color: #efefef;
}

/* 즐겨찾기 */
.favorites-box {
  padding: 0;
  min-width: 300px;
  max-width: 300px;
}

.favorites-box > ul {
  padding-top: 10px;
}

.aside-collapsed.favorites-next-box {
  width: 200px;
  left: -90%;
  top: 66%;
}

.fa-tree-item .material-symbols-outlined {
  font-size: 18px;
  margin-right: 8px;
  font-variation-settings: "wght" 300;
}

.fa-tree-item .collapsed-list {
}

.fa-tree-item .collapsed-list li {
  display: flex;
  align-items: center;
  cursor: pointer;
}

/* Fade Favorite List */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

/* 약품정보 */
.medicine-box {
  position: fixed;
  transform: translateY(0);
  top: 0;
  right: 60px;
  height: 100vh;
  min-width: 850px;
  padding: 20px 24px;
  border: 0;
}

/* 즐겨찾기 */
.favorites-box {
  position: fixed;
  transform: translateY(0);
  top: 0;
  right: 60px;
  height: 100vh;
  min-width: 850px;
  padding: 0;
  border: 0;
}

/* 분석 기록 */
.analysisRecord-box {
  position: fixed;
  transform: translateY(0);
  top: 0;
  right: 60px;
  height: 100vh;
  min-width: 850px;
  width: 850px;
  padding: 0;
  border: 0;
}

/* 추출 */
.extraction-box {
  position: fixed;
  transform: translateY(0);
  top: 0;
  right: 60px;
  height: 100vh;
  min-width: 850px;
  width: 850px;
  padding: 0;
  border: 0;
}

.alert-dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: calc(100% - 60px);
  height: 100%;
}
</style>
